import { useCallback } from 'react';

import { useAuthCache } from 'api/cache';
import {
  ReadingCacheType,
  useReadAPIWithServices,
} from 'api/useAPIWithServices';
import { useAppServices } from 'container/depContext';
import { AccountLinkingInfo } from 'container/services/users/IUserRepo';

export function useAccountLinkingConfig(): {
  info?: AccountLinkingInfo;
  refresh: () => Promise<void>;
} {
  const { getUserRepo } = useAppServices();
  const { getCurrentUserInfo, getUserAccountLinkingState } = getUserRepo();

  const { loggedIn } = useAuthCache();

  const { data: user } = useReadAPIWithServices(
    [loggedIn ? getCurrentUserInfo.name : null], // only try loading user data if we're logged in
    getCurrentUserInfo,
    { cacheType: ReadingCacheType.ExecutionMainEntity }
  );

  const { data: accountLinkingInfo, mutate: refresh } = useReadAPIWithServices(
    [getUserAccountLinkingState.name, user],
    () => getUserAccountLinkingState(user!),
    { cacheType: ReadingCacheType.ExecutionMainEntity }
  );

  return {
    info: accountLinkingInfo,
    refresh: useCallback(async () => {
      await refresh();
    }, [refresh]),
  };
}
